module.exports = __webpack_public_path__ + "static/media/WA3F2000.930300d6.svg";